import React from 'react'
import './DateArea.scss'
import {Grid, Box} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import ErrorIcon from '@material-ui/icons/ErrorOutline'
import _ from 'lodash'

export default function OngoingInfoDesign({
  state,
  status,
  approveClick,
  rejectClick,
  reservationDone,
  reservationStarted,
  hasApprovalManager,
}) {
  return (
    <>
      {hasApprovalManager && (
        <>
          <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
            <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
              <CheckIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '1px solid #3473ff',
                  color: 'white',
                  backgroundColor: '#3473ff',
                  marginRight: '8px',
                }}
              />
              Requested&nbsp;
              <Box color="#1d2331">- Approved</Box>
            </div>
          </div>
          <div
            className="reservation-bookings-info-area__vertical-line"
            style={{borderLeft: '2px solid #3473ff'}}
          />
        </>
      )}
      <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
        <div style={{display: '-webkit-inline-box', marginTop: '2px'}}>
          <CheckIcon
            style={{
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              border: '1px solid #3473ff',
              color: 'white',
              backgroundColor: '#3473ff',
              marginRight: '8px',
            }}
          />
          Upcoming&nbsp;
          {reservationStarted <= 0 && <Box color="#1d2331">- Outstanding</Box>}
        </div>
      </div>
      <div
        className="reservation-bookings-info-area__vertical-line"
        style={{borderLeft: '2px solid #3473ff'}}
      />
      <div style={{fontSize: '14px', textTransform: 'capitalize', marginBottom: '34px'}}>
        {reservationDone >= 0 && (
          <div style={{display: '-webkit-inline-box', marginTop: '2px'}}>
            <div
              className="reservation-bookings-info-area__outer-circle"
              style={{
                backgroundColor: rejectClick ? '#ff2020' : '',
                borderColor: rejectClick ? '#ff2020' : '',
              }}
            >
              <div className="reservation-bookings-info-area__inner-circle" />
            </div>
            Fulfilled
          </div>
        )}
        {reservationDone < 0 && (
          <div style={{display: '-webkit-inline-box'}}>
            <ErrorIcon
              style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                border: '0px solid #edc43e',
                color: 'white',
                backgroundColor: '#edc43e',
                marginRight: '8px',
              }}
            />
            <>Fulfilled&nbsp;</>
            {state === 'overdue' && <Box color="#1d2331">- Overdue</Box>}
          </div>
        )}
      </div>
    </>
  )
}
